import type { ReactElement } from 'react';
import { Song } from 'services/store/songs/types';
import getFirstMoods from 'services/helpers/general/getFirstMoods';
import { BpmTag } from 'pages/SongDetails/components/SongInfo/components';
import Tags from './components/Tags';
import { StyledGrid } from './styled';

type PropsType = {
  song: Song;
};

const SongInfo = ({ song }: PropsType): ReactElement => {
  // @ts-ignore
  const { tempoBPM, genres, eras, energies, keys } = song;
  const songMoods = getFirstMoods(song, 2);

  return (
    <StyledGrid container>
      <BpmTag bpm={tempoBPM} />
      <Tags tags={genres} />
      <Tags tags={keys} />
      <Tags tags={songMoods} />
      <Tags tags={eras} />
      <Tags tags={energies} />
    </StyledGrid>
  );
};

export default SongInfo;
